import { featureIcons } from '@/components/Menu/featureicons';
import { getEnsureLoadedLoader } from './loaderHelper';

export const useOrganizersLoader = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void) => {
    AddLoader(getEnsureLoadedLoader('Organizers'), 'organizers.loading_organizers', featureIcons.INFO);
};
